<template>
  <a-modal
    title="导入邮箱"
    centered
    :width="640"
    :mask-closable="false"
    :visible="showUploadForm"
    :confirmLoading="loading"
    @cancel="close"
  >
    <a-form-model
      ref="form"
      :model="model"
      :rules="rules"
      :label-col="labelCol"
      :wrapper-col="wrapperCol"
      >
        <a-spin :spinning="loading">
          <a-form-model-item label="下载模版" help="点击下载模版">
            <a :href="url" target="_blank">下载模版</a>
          </a-form-model-item>
          
          <a-form-model-item label="表格文件" prop="file" help="仅支持xls,xlsx文件格式">
            <a-upload accept=".xls,.xlsx" :file-list="fileList" :remove="handleRemove" :before-upload="beforeUpload">
              <a-button v-if="fileList.length === 0"> <a-icon type="upload" /> 选择文件 </a-button>
            </a-upload>
          </a-form-model-item>

          <a-form-model-item label="邮箱" prop="email" help="后台配置的登录邮箱">
            <a-select show-search allow-clear placeholder="请选择" v-model="model.email"
                      option-filter-prop="children">
              <a-select-option :value="item.id" v-for="item in emails" :key="item.id">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-spin>
      </a-form-model>

    <template slot="footer">
      <a-button @click="close" :disabled="loading">取消</a-button>
      <a-button type="primary" @click="submit" :disabled="loading">确定</a-button>
    </template>
  </a-modal>
</template>

<style lang="less" scoped>
@import 'Upload';
</style>

<script>
import Upload from './Upload'
export default Upload
</script>
